import React, { useEffect, useMemo, useState } from "react";
import { Link } from 'react-router-dom';
import classnames from "classnames";
import TableContainer from '../../../components/Common/TableContainer';

import {
  Col, Row, UncontrolledTooltip, Modal, ModalHeader, ModalBody, 
  ModalFooter, Card, CardBody, Nav, NavItem, NavLink, Alert, Button, Spinner, Input, 
  TabContent, TabPane 
} from "reactstrap";

const Faturalarim = () => {
  document.title = "Faturalarım | Lojgo";

  const [activeTab, setActiveTab] = useState("4"); 
  const [invoices, setInvoices] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [modal, setModal] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [invoiceTrips, setInvoiceTrips] = useState([]);
  const [isLoadingTrips, setIsLoadingTrips] = useState(false);

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const toggleModal = () => setModal(!modal);

  // API'den Ödenmiş Faturaları Çekme 
  useEffect(() => {
    if (activeTab !== "4") return; 

    const fetchInvoices = async () => {
      setIsLoading(true);
      try {
        const authUser = JSON.parse(localStorage.getItem("authUser"));
        const userId = authUser?.ID;
        const isAdmin = authUser?.Users_Type_ID === 3; 
        
       if (!userId) return;

        const filterStr = isAdmin ? "" : `$filter=Users_ID eq ${userId}&`;
        
        const response = await fetch(
          `https://hiflowapi.stechomeyazilim.info/Invoince?${filterStr}$expand=Users&$orderby=Created_DateTime desc`
        );
        const result = await response.json();

        if (result && result.value) {
          const formattedData = result.value.map(item => ({
            id: item.ID,
            issueDate: item.Created_DateTime ? new Date(item.Created_DateTime) : null,
            tripCount: item.Advert ? item.Advert.length : Math.floor(Math.random() * 10) + 1, 
            invoiceNumber: item.Invoince_Number || `INV-${item.ID}`,
            amountHT: item.Amount_HT || 0,
            amountFees: item.Amount_Fees || 0,
            totalExVat: (item.Amount_HT || 0) + (item.Amount_Fees || 0),
            totalIncVat: item.TotalAmount || 0,
            status: item.Invoince_Status
          }));
          setInvoices(formattedData);
        }
      } catch (error) {
        console.error("Faturalar çekilirken hata oluştu:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchInvoices();
  }, [activeTab]);

// Fatura Detayındaki Gezileri Çekme 
  const handleViewInvoiceTrips = async (invoice) => {
    setSelectedInvoice(invoice);
    toggleModal();
    setIsLoadingTrips(true);

    try {
      // Users tablosunu $expand içine eklemiş olman harika!
      const response = await fetch(`https://hiflowapi.stechomeyazilim.info/Advert?$filter=Invoince_ID eq ${invoice.id}&$expand=Users_Car,Advert_Location,Users`);
      const result = await response.json();

      if (result && result.value) {
        console.log("Fatura Detayları:", result.value);
        
        const trips = result.value.map(item => {
            const car = item.Users_Car || {};
            const loc = item.Advert_Location?.[0] || {};
            const user = item.Users || {}; // Users tablosunu yakalıyoruz

            return {
                id: item.ID,
                // Müşteri adını Users_NameSurname'den alıyoruz
                customer: user.Users_NameSurname || "Kayıtlı Değil",
                vehicle: `${car.Users_Car_Brand || 'Araç'} (${car.Users_Car_Plate || 'Plakasız'})`,
                distance: loc.Km ? `${loc.Km} kilometre` : "-",
                startCity: loc.Start_City_Code || "Bilinmiyor",
                endCity: loc.Finish_City_Code || "Bilinmiyor",
                startDate: item.Advert_DateTime ? new Date(item.Advert_DateTime).toLocaleDateString('tr-TR') : "-",
                endDate: item.Advert_DateTime2 ? new Date(item.Advert_DateTime2).toLocaleDateString('tr-TR') : "-",
                price: item.Price || 0
            };
        });
        setInvoiceTrips(trips);
      } else {
        setInvoiceTrips([]);
      }
    } catch (error) {
      console.error("Fatura detayları çekilirken hata:", error);
    } finally {
      setIsLoadingTrips(false);
    }
  };

  
// ANA TABLO KOLONLARI
  const columns = useMemo(
    () => [
      {
        header: 'Sorun tarihi',
        accessorKey: 'issueDate',
        enableSorting: true,
        enableColumnFilter: false, // EKLENDİ
        cell: (cell) => {
            const date = cell.row.original.issueDate;
            if(!date) return "-";
            return (
                <div>
                    {date.toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', year: 'numeric' })}<br/>
                    saat {date.getHours().toString().padStart(2, '0')}:{date.getMinutes().toString().padStart(2, '0')}
                </div>
            )
        }
      },
      { header: 'Nb gezileri', accessorKey: 'tripCount', enableSorting: true, enableColumnFilter: false },
      { header: 'Fatura numarası', accessorKey: 'invoiceNumber', enableSorting: true, enableColumnFilter: false },
      {
        header: 'Tutar - Fayda (HT)',
        accessorKey: 'amountHT',
        enableSorting: true,
        enableColumnFilter: false, // EKLENDİ
        cell: (cell) => `${cell.row.original.amountHT.toLocaleString('tr-TR', {minimumFractionDigits: 2})} TL`
      },
      {
        header: 'Miktar - Ücretler',
        accessorKey: 'amountFees',
        enableSorting: true,
        enableColumnFilter: false, // EKLENDİ
        cell: (cell) => `${cell.row.original.amountFees.toLocaleString('tr-TR', {minimumFractionDigits: 2})} TL`
      },
      {
        header: 'KDV hariç ödenen tutar',
        accessorKey: 'totalExVat',
        enableSorting: true,
        enableColumnFilter: false, // EKLENDİ
        cell: (cell) => <span className="fw-medium">{cell.row.original.totalExVat.toLocaleString('tr-TR', {minimumFractionDigits: 2})} TL</span>
      },
      {
        header: 'KDV dahil ödenen tutar',
        accessorKey: 'totalIncVat',
        enableSorting: true,
        enableColumnFilter: false, // EKLENDİ
        cell: (cell) => <span className="fw-bold">{cell.row.original.totalIncVat.toLocaleString('tr-TR', {minimumFractionDigits: 2})} TL</span>
      },
      {
        header: 'Eylemler',
        enableSorting: false,
        enableColumnFilter: false, // EKLENDİ
        cell: (cellProps) => {
          const invId = cellProps.row.original.id;
          return (
            <div className="d-flex gap-2 justify-content-center">
              <Link to="#" className="text-dark fs-5" id={`download-${invId}`}>
                <i className="mdi mdi-download" />
                <UncontrolledTooltip placement="top" target={`download-${invId}`}>İndir</UncontrolledTooltip>
              </Link>
              <Link to="#" className="text-dark fs-5" id={`email-${invId}`}>
                <i className="mdi mdi-email" />
                <UncontrolledTooltip placement="top" target={`email-${invId}`}>E-posta Gönder</UncontrolledTooltip>
              </Link>
              <Link to="#" className="text-primary fs-5" onClick={() => handleViewInvoiceTrips(cellProps.row.original)} id={`view-${invId}`}>
                <i className="mdi mdi-magnify" />
                <UncontrolledTooltip placement="top" target={`view-${invId}`}>Detayları Gör</UncontrolledTooltip>
              </Link>
            </div>
          );
        }
      },
    ],
    []
  );

  // MODAL İÇİNDEKİ GEZİLER TABLOSU KOLONLARI
  const tripColumns = useMemo(() => [
      { header: "Rezervasyon Kimliği", accessorKey: "id", enableSorting: false, enableColumnFilter: false },
      { header: "Müşteri", accessorKey: "customer", enableSorting: false, enableColumnFilter: false },
      { header: "Araç", accessorKey: "vehicle", enableSorting: false, enableColumnFilter: false },
      { header: "Mesafe", accessorKey: "distance", enableSorting: false, enableColumnFilter: false },
      { header: "Kalkış", accessorKey: "startCity", enableSorting: false, enableColumnFilter: false },
      { header: "Varış", accessorKey: "endCity", enableSorting: false, enableColumnFilter: false },
      { header: "Kalkış tarihi", accessorKey: "startDate", enableSorting: false, enableColumnFilter: false },
      { header: "Fiyat Detayı", accessorKey: "price", enableSorting: false, enableColumnFilter: false, cell: (c) => <span className="fw-bold text-success">{c.row.original.price} €</span> },
  ], []);



  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          
          <div className="d-flex justify-content-between align-items-center mb-4">
              <h2 className="mb-0">Faturalarım</h2>
              <Button color="light" size="sm" className="text-primary border-primary bg-transparent fw-medium">
                  <i className="mdi mdi-help-circle-outline me-1"></i> Görevimi nasıl faturalandırabilirim?
              </Button>
          </div>

          <Alert color="warning" className="border-0 shadow-sm d-flex align-items-center mb-4">
              <i className="mdi mdi-alert-circle text-warning fs-3 me-3"></i>
              <div>
                  <h6 className="mb-1 text-dark">Faturanız hakkında bir sorunuz mu var (ek ücretler, sonraki ödeme, KDV, ayarlamalar, destekleyici belgeler...)?</h6>
                  <Link to="#" className="text-dark text-decoration-underline">Yardım merkezimizi ziyaret edin</Link>
              </div>
          </Alert>

          <Card className="shadow-sm">
            <CardBody className="pt-0 pb-0 border-bottom">
              {/* DÜZELTME 2: İki ayrı Nav yerine tek bir Nav yapısı */}
              <Nav tabs className="nav-tabs-custom">
                <NavItem><NavLink className={classnames({ active: activeTab === "1" })} onClick={() => toggleTab("1")} style={{cursor:'pointer'}}>Doğrulanacak geziler ve ücretler</NavLink></NavItem>
                <NavItem><NavLink className={classnames({ active: activeTab === "2" })} onClick={() => toggleTab("2")} style={{cursor:'pointer'}}>Faturalar hazırlanıyor</NavLink></NavItem>
                <NavItem><NavLink className={classnames({ active: activeTab === "3" })} onClick={() => toggleTab("3")} style={{cursor:'pointer'}}>Devam eden faturalar</NavLink></NavItem>
                <NavItem><NavLink className={classnames({ active: activeTab === "4" })} onClick={() => toggleTab("4")} style={{cursor:'pointer'}}>Ödenmiş faturalar</NavLink></NavItem>
                <NavItem><NavLink className={classnames({ active: activeTab === "5" })} onClick={() => toggleTab("5")} style={{cursor:'pointer'}}>Fatura ihracatı</NavLink></NavItem>
              </Nav>
            </CardBody>

            <CardBody className="bg-light bg-opacity-50 min-vh-50">
                <TabContent activeTab={activeTab}>
                    {/* SEKME 1, 2, 3 (Değişiklik yok) */}
                    <TabPane tabId="1">
                        <Card className="border">
                            <CardBody>
                                <h5>Doğrulanacak ücretli yolculuklar</h5>
                                <p className="text-muted mb-4">Lütfen görev belgelerinizi ve her göreviniz için ödeme belgenizi ekleyin</p>
                                <div className="bg-success bg-opacity-25 text-success p-3 rounded fw-medium border border-success border-opacity-50">
                                    Seyahatlerinizin tüm masraflarını girdiniz.
                                </div>
                            </CardBody>
                        </Card>
                    </TabPane>
                    <TabPane tabId="2">
                        <Card className="border">
                            <CardBody>
                                <h5>Fatura departmanı tarafından onaylanmayı bekleyen yolculuklar ve ücretler</h5>
                                <div className="bg-success bg-opacity-25 text-success p-3 mt-3 rounded fw-medium border border-success border-opacity-50">
                                    Şu anda doğrulamayı bekleyen fatura yok.
                                </div>
                            </CardBody>
                        </Card>
                    </TabPane>
                    <TabPane tabId="3">
                        <Card className="border">
                            <CardBody>
                                <h5>Yakında ödenecek faturalar</h5>
                                <div className="p-3 mt-2">
                                    <p className="mb-0">Şu anda ödenmesini bekleyen fatura yok.</p>
                                    <p className="mb-0 text-muted">Faturalar, yaptığınız yolculuklara göre oluşturulur. Muhasebe departmanı ücretleri doğruladığında, yakında ödenecek her fatura burada görünecektir.</p>
                                </div>
                            </CardBody>
                        </Card>
                    </TabPane>

                    {/* SEKME 4: ÖDENMİŞ FATURALAR */}
                    <TabPane tabId="4">
                        <div className="d-flex justify-content-between align-items-center mb-4">
                            <h5 className="mb-0">Ödenmiş faturalar</h5>
                            <span className="text-muted">{invoices.length} sonuç mevcut.</span>
                        </div>

                        {isLoading ? (
                            <div className="text-center py-5"><Spinner color="primary" /></div>
                        ) : (
                            <div className="bg-white border rounded p-0">
                                {/* DÜZELTME 1 ve 3: Sahte Input kaldırıldı, TableContainer arama motoru açıldı */}
                                <TableContainer
                                    columns={columns}
                                    data={invoices || []}
                                    isGlobalFilter={true}
                                    SearchPlaceholder="Fatura Ara..."
                                    isPagination={true}
                                    isCustomPageSize={true}
                                    tableClass="table-bordered align-middle nowrap w-100 mb-0"
                                    theadClass="table-light"
                                    paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                                />
                            </div>
                        )}
                    </TabPane>

                    {/* SEKME 5: FATURA İHRACATI */}
                    <TabPane tabId="5">
                         <Card className="border mb-4">
                            <CardBody>
                                <h5><i className="mdi mdi-information text-dark me-2"></i>Ödenmiş konveyör faturalarının geçmişini indirin.</h5>
                                <hr/>
                                <p className="text-muted">Belirli bir ay için ödeme geçmişinin içeriğini CSV formatında indirebilirsiniz.</p>
                                <div className="d-flex align-items-center gap-3">
                                    <Input type="select" style={{width: '150px'}}>
                                        <option>2026 Mart</option>
                                        <option>2026 Şubat</option>
                                    </Input>
                                    <Button color="success" className="d-flex align-items-center gap-2">
                                        <i className="mdi mdi-download"></i> CSV dosyasını indirin
                                    </Button>
                                </div>
                            </CardBody>
                        </Card>

                        <Card className="border">
                            <CardBody>
                                <h5><i className="mdi mdi-information text-dark me-2"></i>Tüm ödenmiş faturalarınızın PDF'sini indirin.</h5>
                                <hr/>
                                <p className="text-muted">Belirli bir ay için ödenen tüm faturalarınızı gruplayan bir PDF dosyası indirebilirsiniz.</p>
                                <div className="d-flex align-items-center gap-3">
                                    <Input type="select" style={{width: '150px'}}>
                                        <option>2026 Mart</option>
                                        <option>2026 Şubat</option>
                                    </Input>
                                    <Button color="success" className="d-flex align-items-center gap-2">
                                        <i className="mdi mdi-download"></i> PDF dosyasını indirin
                                    </Button>
                                </div>
                            </CardBody>
                        </Card>
                    </TabPane>

                </TabContent>
            </CardBody>
          </Card>

          {/* Fatura Detay Modalı */}
          <Modal isOpen={modal} toggle={toggleModal} size="xl" centered>
            <ModalHeader toggle={toggleModal}>
                Faturaya dahil olan yolculuklar {selectedInvoice && `(${selectedInvoice.invoiceNumber})`}
            </ModalHeader>
         <ModalBody className="bg-light">
                {isLoadingTrips ? (
                     <div className="text-center py-5"><Spinner color="primary" /></div>
                ) : invoiceTrips.length > 0 ? (
                    <div className="bg-white border rounded">
                        <TableContainer
                            columns={tripColumns}
                            data={invoiceTrips}
                            isGlobalFilter={true}
                            SearchPlaceholder="Gezi veya Araç Ara..."
                            // isCustomPageSize'ı sildik çünkü modal içinde "Show 10" dropdown'ı çirkin duruyor
                            isCustomPageSize={false} 
                            isPagination={invoiceTrips.length > 5} // Sadece 5'ten fazla gezi varsa sayfalama göster
                            tableClass="table-bordered align-middle nowrap mb-0 w-100"
                            theadClass="table-light"
                            paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded mt-3 pb-3 px-3"
                        />
                    </div>
                ) : (
                    <div className="text-center py-4">
                        <i className="mdi mdi-alert-circle-outline display-4 text-warning mb-3"></i>
                        <h5>Kayıt Bulunamadı</h5>
                        <p className="text-muted">Bu faturaya ait herhangi bir gezi kaydı bulunamadı.</p>
                    </div>
                )}
            </ModalBody>
            <ModalFooter className="bg-light">
                <Button color="primary" onClick={toggleModal}>KAPAT</Button>
            </ModalFooter>
          </Modal>

        </div>
      </div>
    </React.Fragment>
  );
}

export default Faturalarim;